import React from "react";

export default function Tags({ tags = [], className = "skill-tag", style }) {
  if (tags.length === 0) return null;
  return (
    <div style={style}>
      {tags.map((tag, index) => (
        <div className={className} key={index}>
          {tag}
        </div>
      ))}
    </div>
  );
}
